import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { Observable, Subject } from 'rxjs';
import { filter, finalize, map, shareReplay, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA, ROLE_COTISTA_CONSULTA, ROLE_GESTOR_AVALIADOR_FGE, ROLE_DEPR_CONSULTA, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Aviso } from 'src/app/model/aviso.model';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { MonitoracaoService } from '../../shared/services/monitoracao.service';
import { AvisoService } from '../aviso/aviso.service';
import { DataSistemaService } from 'src/app/shared/services/data-sistema.service';
import Utils from 'src/app/shared/fgi-utils';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import moment from "moment";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private cnpjAgente: string = null;
    versao = '';
    dataCorrenteStr = '';
    avisos$: Observable<Aviso[]>;
    avisosAdministrador$: Observable<Aviso[]>;
    usuarioSemPermissao$: Observable<Boolean>;
    usuarioConsulta$: Observable<Boolean>;
    usuarioAvaliadorFge$: Observable<Boolean>;
    private dataSistema: string;
    private dataSistemaSeteDiasAntes: string;
    private readonly destroy$ = new Subject();

    constructor(
        private modalidadeService: ModalidadeService,
        private monitoracaoService: MonitoracaoService,
        private permissaoService: PermissaoService,
        private usuarioService: BnUsuarioService,
        private avisoService: AvisoService,
        private fileUtils: FileUtilsService,
        private activatedRoute: ActivatedRoute,
        private loadingService: BnLoadingService,
        private dataSistemaService: DataSistemaService,
        private dominiosService: DominiosService) {
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    }

    ngOnInit() {
        this.getVersao();
        this.getDataCorrente();
        this.obterData();
        //Erro do loading infinito escolha-modalidade
        //this.loadingService.bloqueiaTela();

        const permissoes$ = this.permissaoService.getPermissoesUsuarioAutenticado().pipe(
            take(1),
            shareReplay(1),
            finalize(() => this.loadingService.liberaTela())
        );
        
        this.usuarioSemPermissao$ = permissoes$.pipe(
            map(prm => !prm || (!prm[ROLE_GESTOR_CONSULTA] && !prm[ROLE_AGENTE_CONSULTA]))
        );

        this.usuarioConsulta$ = permissoes$.pipe(
            map(prm => !!prm?.[ROLE_COTISTA_CONSULTA] || prm?.[ROLE_DEPR_CONSULTA])
        );

        this.usuarioAvaliadorFge$ = permissoes$.pipe(
            map(prm => !!prm?.[ROLE_GESTOR_AVALIADOR_FGE])
        );

        this.avisosAdministrador$ = this.usuarioService.usuario$.pipe(
            filter(usuario => usuario !== null),
            switchMap(usuario => this.buscaCnpjCasoSejaUmAgenteFinanceiro(usuario)),
            switchMap(cnpjAgente => this.avisoService.getAvisosConfirmacao(cnpjAgente, true)),
            map(res => res ? res.resultados : undefined),
        );

        this.avisos$ = this.usuarioService.usuario$.pipe(
            filter(usuario => usuario !== null),
            switchMap(usuario => this.buscaCnpjCasoSejaUmAgenteFinanceiro(usuario)),
            switchMap(cnpjAgente => this.avisoService.getAvisosConfirmacao(cnpjAgente, false)),
            map(res => res ? res.resultados : undefined),
        );

    }

    public obterData() {
        this.dominiosService.getTimeStampISO()
          .pipe(takeUntil(this.destroy$))
          .subscribe((dataAtual: any) => {
            this.dataSistema = moment(dataAtual.nowDateISO, 'YYYYMMDD').format('YYYYMMDD');
            this.dataSistemaSeteDiasAntes = moment(dataAtual.nowDateISO, 'YYYYMMDD').subtract(7, 'days').format('YYYYMMDD');
          })
      }

    public obterModalidade() {
        return this.modalidadeService.modalidadeTitulo$;
    }

    get ehUsuarioAgente(): boolean {
        return !!this.cnpjAgente;
    }

    private buscaCnpjCasoSejaUmAgenteFinanceiro(usuario): string {
        this.loadingService.bloqueiaTela();
        return this.permissaoService.getPermissoesUsuarioAutenticado().pipe(
            take(1),
            tap(() => this.loadingService.liberaTela()),
            filter(prm => prm && prm[ROLE_AGENTE_CONSULTA]),
            map(() => {
                this.cnpjAgente = usuario && usuario.cnpj; // remover quando tirar o cnpjagente
                return this.cnpjAgente;
            }),
        );
    }

    getVersao() {
        this.monitoracaoService.getVersao().subscribe(respostaVersao => this.versao = respostaVersao.versao);
    }

    getDataCorrente() {
      this.dataSistemaService.getDataCorrenteStr().subscribe(
          dataCorrente => this.dataCorrenteStr = dataCorrente ? (" - " + dataCorrente) : '');
    }

    nomeAgente(id: number) {
        return Utils.nomeAgentePorId(id, this.agentesFinanceiros);
    }

    exportarAnexo(aviso: Aviso) {
        this.avisoService.getAnexo(aviso.id).subscribe((conteudo) => {
            this.fileUtils.exportarArquivo('Aviso_' + aviso.id + '.csv', conteudo, FileUtilsService.TEXT_CSV);
        });
    }

}
